import splide from "@splidejs/splide";
import "@splidejs/splide/css";

export const initSlideshows = () => {
	if (!document.querySelector(".splide")) {
		return;
	}
	if (document.querySelector(".service-and-intitiave-slider")) {
		new splide(".service-and-intitiave-slider", {
			type: "loop",
			perPage: 1,
			perMove: 1,
			gap: "1rem",
			padding: { left: '0rem', right: '8rem' },
			pagination: false,
			classes: {
				prev: "splide__arrow--prev",
				next: "splide__arrow--next",
			},
		}).mount();
	}

	if (document.querySelector(".help-service-slider")) {
		new splide(".help-service-slider", {
			type: "loop",
			perPage: 3,
			perMove: 1,
			gap: "1rem",
			pagination: false,
			classes: {
				prev: "splide__arrow--prev",
				next: "splide__arrow--next bouncy-button",
			},
			breakpoints: {
				800: {
					perPage: 2,
				},
				700: {
					perPage: 1,
				},
			},
		}).mount();
	}

	if (document.querySelector(".mini-help-service-slider")) {
		new splide(".mini-help-service-slider", {
			type: "loop",
			perPage: 1,
			perMove: 1,
			gap: "1rem",
			pagination: false,
			classes: {
				prev: "splide__arrow--prev dark-btn",
				next: "splide__arrow--next dark-btn",
			},
		}).mount();
	}

	if (document.querySelector(".agency-partner-slider")) {
		new splide(".agency-partner-slider", {
			type: "loop",
			perPage: 6,
			perMove: 3,
			gap: "2rem",
			pagination: false,
			classes: {
				prev: "splide__arrow--prev",
				next: "splide__arrow--next",
			},
			breakpoints: {
				800: {
					perPage: 2,
				},
				600: {
					perPage: 1,
				},
			},
		}).mount();
	}

	var heroSlider = document.querySelectorAll('.home-page-hero');
	
	if(heroSlider) {
			heroSlider.forEach(function(parent) {
				// console.log(`parent: `, parent)

			// Detect number of slides to avoid sliding when only one slide exists
			const slideCount = parent.querySelectorAll('.splide__list > .splide__slide').length || 0;
			const isSingleSlide = slideCount <= 1;

			const heroSlider = new splide(parent, {
				type: isSingleSlide ? 'slide' : 'loop',
				perPage: 1,
				pagination: !isSingleSlide,
				arrows: false,
				perMove: 1,
				autoplay: !isSingleSlide,
				interval: 9500,
				pauseOnHover: true,
				pauseOnFocus: true,
				drag: !isSingleSlide,
				keyboard: !isSingleSlide,
				classes: {
					pagination: 'splide__pagination hero-slider-pagination',
				},
			});
			heroSlider.mount();

            // After mount, move pagination into a static container under the track.
			function movePaginationToStaticContainer(){
				var pag = parent.querySelector('.hero-slider-pagination');
				var host = parent.querySelector('.hero-pagination');
				if (pag && host && !host.contains(pag)) {
					host.appendChild(pag);
				}
			}

            // No dynamic positioning: alignment handled via CSS only.

            heroSlider.on('mounted', function(){
                if (!isSingleSlide) movePaginationToStaticContainer();
            });
            setTimeout(function(){
                if (!isSingleSlide) movePaginationToStaticContainer();
            }, 0);

            // Theme class handling only when pagination exists
            if (!isSingleSlide) {
                var heroSliderPagination = parent.querySelector('.hero-slider-pagination');
                var slides = heroSlider.Components.Slides;
                var activeSlide = slides.getAt(heroSlider.index);
                var theme = (`theme-${activeSlide.slide.dataset.theme}` || '').trim();
                if (heroSliderPagination) heroSliderPagination.classList.add(theme);
                // Also color the hero host so the area below the track matches the slide
                if (theme) parent.classList.add(theme);

                heroSlider.on('move', () => {
                    var activeSlide = slides.getAt(heroSlider.index);
                    var theme = (`theme-${activeSlide.slide.dataset.theme}` || '').trim();
                    if (!heroSliderPagination) return;
                    if (heroSliderPagination.className.includes('theme-')) {
                        var classNames = heroSliderPagination.className.split(' ');
                        classNames.forEach(function(ind) {
                            if(ind.includes('theme-')) {
                                heroSliderPagination.classList.remove(ind);
                            }
                        });
                    }
                    heroSliderPagination.classList.add(theme);

                    // Sync hero host theme as slide changes
                    if (parent.className.includes('theme-')) {
                        var pClasses = parent.className.split(' ');
                        pClasses.forEach(function(ind){
                            if (ind.includes('theme-')) parent.classList.remove(ind);
                        });
                    }
                    if (theme) parent.classList.add(theme);
                });
            }

		});
	}
};
